'use client';
import Script from 'next/script';
import { useEffect } from 'react';

const CleanhubScript = () => {
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const iframe = document.querySelector("iframe[src*='cleanhub']");
      if (iframe && !iframe.title) {
        iframe.title = 'Cleanhub Environmental Impact Tracker';
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Script
        src="https://cdn.cleanhub.io/embed/CleanhubBanner.js"
        strategy="lazyOnload"
        onReady={() => {
          window.CleanhubBanner.elements = new Map();
          window.CleanhubBanner.mount({
            clientId: '1tehgkee2a4ptqi3rd8j56ujo70io2s142ru5aei',
            elementId: 'cleanhub-banner'
          });
        }}
        data-cy="cleanhub-script"
      />
      <div
        id="cleanhub-banner"
        className="mb-8 min-h-70 bg-transparent sm:min-h-38"
        data-cy="cleanhub-banner"
      ></div>
    </>
  );
};

export default CleanhubScript;
